import { SVGProps } from 'react';

const SvgYoutube = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.524 3.556S20 5.619 20 8s-.476 4.444-.476 4.444c0 .318-.857 2.223-1.905 2.223 0 0-2.857.476-7.619.476s-7.619-.476-7.619-.476c-1.048 0-1.905-1.905-1.905-2.223C.476 12.444 0 10.381 0 8c0-2.38.476-4.444.476-4.444 0-.318.857-2.223 1.905-2.223 0 0 2.857-.476 7.619-.476s7.619.476 7.619.476c1.048 0 1.905 1.905 1.905 2.223ZM13.334 8 8.094 5.32v5.35L13.333 8Z"
      fill={fill || '#1D252C'}
    />
  </svg>
);

export default SvgYoutube;
